<template>
    <div>
        <!-- Payment modes div -->
        <div class="payment-mode">
            <div 
            class="card"
            @click="selectedMode= 'credit-card'"
            :class="{active: selectedMode ==='credit-card'}">
                <svg width="14" height="11" viewBox="0 0 14 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12.5324 0H1.47072C0.539304 0 0 0.581922 0 1.58229C0 4.18042 0 6.77855 0 9.37667C0 10.4275 0.532414 10.9993 1.50329 11H6.99906C8.83891 11 10.6786 11 12.518 11C13.4663 11 14 10.4255 14 9.40695C14 6.8003 14 4.19365 14 1.587C14.0025 0.589322 13.4576 0 12.5324 0ZM13.0999 10.2654C12.8958 10.3665 12.6732 10.4173 12.4485 10.414C9.56717 10.4235 6.68587 10.4201 3.80457 10.4201C3.01409 10.4201 2.22361 10.4241 1.43251 10.4201C0.853116 10.4161 0.539931 10.0931 0.536173 9.47355C0.528656 8.01034 0.536173 6.54712 0.536173 5.08391C0.536173 5.04287 0.544315 5.00183 0.551205 4.93254H13.4457C13.4566 4.99205 13.4637 5.05229 13.467 5.11284C13.467 6.55878 13.467 8.00495 13.467 9.45135C13.467 9.7857 13.393 10.1073 13.0999 10.266V10.2654ZM13.467 2.60486H0.51425C0.538678 2.11846 0.527403 1.6314 0.600062 1.15913C0.650172 0.832182 0.905731 0.643814 1.22643 0.602777C1.33518 0.589311 1.44456 0.582572 1.55402 0.582594C5.20826 0.582594 8.86209 0.582594 12.5155 0.582594C13.1688 0.582594 13.4638 0.896765 13.4682 1.59642C13.4701 1.92875 13.467 2.26176 13.467 2.60486ZM5.21328 7.30261H12.3257V6.76442H5.21328V7.30261ZM5.21328 8.46107H10.9828V7.92288H5.21328V8.46107ZM4.38459 7.35307C4.3777 6.53636 3.94613 6.07889 3.18634 6.08159C3.04604 6.08159 2.9051 6.07822 2.76417 6.08159C2.48353 6.08466 2.21502 6.2049 2.01546 6.41684C1.81591 6.62879 1.70096 6.91581 1.69496 7.21717C1.68932 7.42707 1.68869 7.63764 1.69496 7.84686C1.71437 8.38505 2.05324 8.84319 2.54682 8.93065C2.85481 8.98392 3.1684 8.98845 3.47761 8.9441C3.93736 8.87683 4.23614 8.56468 4.35452 8.08097C4.39649 7.90539 4.38334 7.71433 4.39586 7.53067H4.38459C4.38459 7.46743 4.38459 7.4116 4.38459 7.35307Z" fill="#1693C8" class="credit-card-icon"/>
                <path d="M12.5324 0H1.47072C0.539304 0 0 0.581922 0 1.58229C0 4.18042 0 6.77855 0 9.37667C0 10.4275 0.532414 10.9993 1.50329 11H6.99906C8.83891 11 10.6786 11 12.518 11C13.4663 11 14 10.4255 14 9.40695C14 6.8003 14 4.19365 14 1.587C14.0025 0.589322 13.4576 0 12.5324 0ZM13.0999 10.2654C12.8958 10.3665 12.6732 10.4173 12.4485 10.414C9.56717 10.4235 6.68587 10.4201 3.80457 10.4201C3.01409 10.4201 2.22361 10.4241 1.43251 10.4201C0.853116 10.4161 0.539931 10.0931 0.536173 9.47355C0.528656 8.01034 0.536173 6.54712 0.536173 5.08391C0.536173 5.04287 0.544315 5.00183 0.551205 4.93254H13.4457C13.4566 4.99205 13.4637 5.05229 13.467 5.11284C13.467 6.55878 13.467 8.00495 13.467 9.45135C13.467 9.7857 13.393 10.1073 13.0999 10.266V10.2654ZM13.467 2.60486H0.51425C0.538678 2.11846 0.527403 1.6314 0.600062 1.15913C0.650172 0.832182 0.905731 0.643814 1.22643 0.602777C1.33518 0.589311 1.44456 0.582572 1.55402 0.582594C5.20826 0.582594 8.86209 0.582594 12.5155 0.582594C13.1688 0.582594 13.4638 0.896765 13.4682 1.59642C13.4701 1.92875 13.467 2.26176 13.467 2.60486Z" fill="#1693C8" class="credit-card-icon"/>
                <path d="M4.39454 7.53002C4.38202 7.71368 4.39454 7.90474 4.3532 8.08032C4.23795 8.56402 3.93917 8.87752 3.47629 8.94345C3.16708 8.9878 2.85349 8.98327 2.5455 8.92999C2.05192 8.84254 1.71305 8.38171 1.69364 7.84621C1.68612 7.63698 1.68675 7.42642 1.69364 7.21652C1.69965 6.91482 1.81486 6.62749 2.01482 6.41549C2.21478 6.20349 2.48377 6.08349 2.76473 6.08093C2.90566 6.08093 3.0466 6.08093 3.1869 6.08093C3.94732 6.08093 4.37701 6.53571 4.38515 7.35241C4.38515 7.41094 4.38515 7.46947 4.38515 7.52867L4.39454 7.53002Z" fill="#1693C8" class="credit-card-icon"/>
                <path d="M12.3257 6.76373H5.21326V7.3026H12.3257V6.76373Z" fill="#1693C8" class="credit-card-icon"/>
                <path d="M10.9827 7.91949H5.21326V8.46105H10.9827V7.91949Z" fill="#1693C8" class="credit-card-icon"/>
                </svg>
                <span class="card-mode">Carte bancaire</span>
            </div>
            <div 
            class="mobile-money"
            @click="selectedMode= 'mobilemoney'"
            :class="{active: selectedMode ==='mobilemoney', disabled: enableMobileMoney === false }">
                <svg width="11" height="12" viewBox="0 0 11 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6.60923 9.81223C6.60923 9.80599 6.60165 9.80019 6.59701 9.79306H5.95417C5.95291 9.86431 5.94671 9.93536 5.93564 10.0056C5.8973 10.1679 5.77598 10.2436 5.56493 10.2436H1.03725C0.998711 10.2441 0.960178 10.2423 0.921824 10.2383C0.853118 10.2314 0.788887 10.1991 0.740315 10.1473C0.691744 10.0954 0.661911 10.0271 0.656011 9.95439C0.651798 9.90671 0.65264 9.85813 0.65264 9.81V4.40674C0.65264 3.64911 0.65264 2.89148 0.65264 2.13385C0.65264 1.89007 0.77312 1.76528 1.00439 1.76528H5.61674C5.83791 1.76528 5.96049 1.89631 5.96302 2.13073C5.96302 2.20337 5.96302 2.27557 5.96302 2.34688H6.60881C6.60881 1.96717 6.62608 1.59504 6.60502 1.22558C6.56331 0.505831 6.04559 0.00311966 5.36146 0C3.99294 0 2.62413 0.001337 1.25504 0.00401099C1.10462 0.00331587 0.9551 0.0284514 0.812297 0.0784372C0.304681 0.2674 0.00137554 0.747827 0.00137554 1.34413C0.00137554 4.16965 0.00137554 6.99532 0.00137554 9.82114C0.00137554 10.1295 -0.00283704 10.4375 0.00348183 10.7459C0.0169621 11.422 0.542271 11.9893 1.183 11.9938C2.60096 12.0021 4.01919 12.0021 5.43771 11.9938C5.72862 11.987 6.00711 11.8677 6.22055 11.6585C6.43399 11.4492 6.56762 11.1646 6.59617 10.8582C6.62313 10.5115 6.6067 10.1612 6.60923 9.81223ZM3.81502 11.446C3.4401 11.4481 3.06519 11.4481 2.69027 11.446C2.47964 11.446 2.34231 11.3061 2.3461 11.1136C2.34989 10.921 2.48806 10.7914 2.70038 10.7905C2.88278 10.7905 3.06476 10.7905 3.24801 10.7905C3.43716 10.7905 3.62714 10.7905 3.81545 10.7905C4.00375 10.7905 4.14024 10.9291 4.13939 11.1189C4.13855 11.3088 4.01133 11.4447 3.81502 11.446Z" fill="#1693C8" class="mobilemoney-icon"/>
                <path d="M10.9983 3.84166C10.9986 3.64259 10.9295 3.45039 10.8041 3.30196C10.6238 3.07913 10.3904 3.00025 10.1199 3.00069C8.85279 3.00307 7.58578 3.00307 6.31892 3.00069C5.05852 3.00069 3.79839 3.00069 2.53855 3.00069C2.44397 2.99798 2.3494 3.0068 2.25673 3.02699C1.86538 3.12637 1.63537 3.46196 1.63495 3.92723C1.63495 5.35693 1.63495 6.78648 1.63495 8.21588C1.6334 8.3057 1.64159 8.39543 1.65938 8.48328C1.75122 8.89418 2.06843 9.14152 2.49895 9.14152H10.1338C10.1621 9.14152 10.1899 9.14152 10.2181 9.14152C10.426 9.13539 10.6234 9.0439 10.7686 8.88643C10.9139 8.72896 10.9955 8.51788 10.9961 8.29788C11.0004 6.81262 11.0011 5.32722 10.9983 3.84166ZM10.2956 7.38917C10.0218 7.36332 9.77492 7.43106 9.57566 7.64097C9.37641 7.85088 9.30648 8.10357 9.33765 8.40083H3.34442C3.37854 7.82369 2.95475 7.34727 2.32876 7.45468V4.8101C3.0171 4.85778 3.34905 4.51061 3.32925 3.75164H9.32375C9.38526 4.49947 9.67129 4.79896 10.2926 4.76598L10.2956 7.38917Z" fill="#1693C8" class="mobilemoney-icon"/>
                <path d="M8.03091 6.08291C8.03091 7.13646 7.22799 7.96807 6.21739 7.96406C5.28009 7.9605 4.49023 7.09724 4.49023 6.08023C4.49023 5.0552 5.28388 4.1915 6.22413 4.19417C7.23852 4.1964 8.03175 5.02579 8.03091 6.08291Z" fill="#1693C8" class="mobilemoney-icon"/>
                <path d="M4.16761 6.17607C4.16642 6.24684 4.15195 6.31666 4.12506 6.38147C4.09817 6.44628 4.05938 6.50481 4.01095 6.55364C3.96251 6.60248 3.9054 6.64065 3.84291 6.66596C3.78043 6.69126 3.71382 6.7032 3.64694 6.70106C3.39418 6.69794 3.1726 6.45639 3.16797 6.17874C3.16875 6.03623 3.22295 5.89987 3.31868 5.7996C3.4144 5.69933 3.54383 5.64335 3.67853 5.64394C3.9414 5.64127 4.17183 5.89129 4.16761 6.17607Z" fill="#1693C8" class="mobilemoney-icon"/>
                <path d="M9.33937 6.17293C9.33937 6.45771 9.11695 6.70149 8.85829 6.70105C8.79156 6.70223 8.72526 6.68941 8.66323 6.66334C8.6012 6.63727 8.54466 6.59847 8.49688 6.54916C8.4491 6.49985 8.41102 6.44103 8.38484 6.37607C8.35867 6.31111 8.34491 6.24132 8.34436 6.17071C8.34436 5.88726 8.56721 5.64393 8.8267 5.64259C8.89354 5.64074 8.96006 5.65311 9.0223 5.67895C9.08454 5.7048 9.14125 5.7436 9.18906 5.79305C9.23687 5.84251 9.2748 5.90162 9.30062 5.96687C9.32644 6.03212 9.33962 6.10219 9.33937 6.17293Z" fill="#1693C8" class="mobilemoney-icon"/>
                </svg>

                <span class="mobile-money-mode">Mobile Money</span>
            </div>
        </div>

        <!-- Icon div -->
        <!-- <div 
        class="icon-div"
        v-if="selectedMode==='mobilemoney'"> -->
            <!-- <div 
            class="mobile-money-icon-div"
            @click="mobileMoneyOption = 'mtn'"
            :class="{mobileMoneyActive: mobileMoneyOption === 'mtn'}">
                <img src="../assets/mobileMoney.svg" alt="mobile-money" class="mobile-money-icon">
            </div> -->
           <!--  <div 
            class="moov-money-icon-div"
            @click="mobileMoneyOption= 'moov'"
            :class="{mobileMoneyActive: mobileMoneyOption === 'moov'}">
                <img src="../assets/moovMoney.svg" alt="moov-money" class="moov-money-icon">
            </div> -->
        <!-- </div> -->

        <!-- Messages div -->
        <div 
        class="messages-div"
        :class="message.class"
        v-if="displayMessage">
            <div class="messages-title">
                <img :src="message.icon" alt="message-icon">
                <span class="msg-title">{{message.title}}</span>
                <img :src="message.close" alt="message-close-icon" @click="displayMessage=!displayMessage">
            </div>
            <div class="messages-content">{{message.content}}</div>
        </div>

        <!-- Form div -->
        <div class="form-div">
            <form-fields 
            :cout="cout" 
            :mode="selectedMode" 
            :numberConsultation="numberConsultation"
            :hasMessage="displayMessage"
            :processComplete="processComplete"
            :fraisTransaction="fraisTransaction"
            :referent="referent"
            :referentPhone="referentPhone"
            :paymentType="selectedMode"
            @show-msg='ShowMessage'
            />
        </div>
        <!-- Sponsors div -->
        <div v-responsive.xs class="sponsor-div">
            <img src="../assets/accredited-business.svg" alt="accredited-business">
            <img src="../assets/trusted-shop.svg" alt="trusted-shop">
            <img src="../assets/geotrust.svg" alt="geotrust">
        </div>
    </div>
</template>

<script>
import FormFields from './FormFields'

let icons ={
    success: {
        open: require('../assets/success-icon.svg'),
        close: require('../assets/success-close.svg')
    },
    error: {
        open: require('../assets/error-icon.svg'),
        close: require('../assets/error-close.svg')
    }
}

export default {
    data: function() {
        return {
            selectedMode: 'credit-card',
            mobileMoneyOption: 'mtn',
            message: {
                title:'Message title',
                content: 'Message content',
                icon: icons.success.open,
                close: icons.success.close,
                class: 'message-success'
            },
            displayMessage: false,
            processComplete: false,
        }
    },
    props:{
        cout: Number,
        patient: String,
        numberConsultation: [String, Number],
        noData: Boolean,
        enableMobileMoney: Boolean,
        fraisTransaction: Number,
        referent: String,
        referentPhone: String
    },
    components: {
        FormFields
    },
    methods: {
        ShowMessage(payload) {
            let message = ''
            if (payload === 'error') {
                message = {
                    title:'Erreur de validation',
                    content: 'Veuillez bien remplir tous les champs du formulaire',
                    icon: icons.error.open,
                    close: icons.error.close,
                    class: 'message-error'
                }
            }else if (payload === 'transaction-error') {
                message = {
                    title:'Echec de paiement',
                    content: `Vous n'avez pas suffisamment d'argent sur votre compte.` ,
                    icon: icons.error.open,
                    close: icons.error.close,
                    class: 'message-error'
                }
            }else if (payload === 'processing-error') {
                message = {
                    title:'Echec de paiement',
                    content: `Une erreur est survenue au cours du processus de paiement.` ,
                    icon: icons.error.open,
                    close: icons.error.close,
                    class: 'message-error'
                }
            }
            else if (payload === 'success') {
                message = {
                    title:'Payement effectué avec succès',
                    content: `Le RDV médical de ${this.patient} est à présent validé.`,
                    icon: icons.success.open,
                    close: icons.success.close,
                    class: 'message-success'
                }
                this.processComplete = true
            }
            else if (payload === 'no_data') {
                message = {
                    title:'Code invalide',
                    content: `Ce code de paiement n'est plus valide.`,
                    icon: icons.error.open,
                    close: icons.error.close,
                    class: 'message-error'
                }
            }
            this.message = message
            this.displayMessage = true
            

            if( payload === 'success') {
                setTimeout( () => {
                    this.displayMessage = false
                },5000)
            } else {
                setTimeout( () => {
                    this.displayMessage = false
                },15000)
            }
        }
    },
    watch: {
        noData: function () {
            this.ShowMessage('no_data')
        }
    }
}
</script>

<style scoped>
/* Global styles */
span {
    display: inline;
}
.payment-content {
    margin-top: 0.6em;
    border: 1px solid #eee;
    background: #fff;
    border-radius: 5px;
}

/* Payment modes styles */
.payment-mode {
    display: flex;
    border-bottom: 1px solid #eee;
    height: 56px;
    align-items: center;
}
.card,.mobile-money {
    flex: 1;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.mobile-money-mode,.card-mode {
    margin-left: 0.250rem;
}
.active {
    border-bottom: 3px solid #1693C8;
    color: #1693C8;
    font-weight: bold;
}
.default {
    color: #eee;
}

/* Icon div styles */
.icon-div {
    display: flex;
    /* max-height: 10vh; */
    padding: 1em;
    justify-content: center;
}
.mobile-money-icon-div,.moov-money-icon-div {
    border: 1px solid #F1F1F1;
    border-radius: 5px;
    margin: 0 5px;
    width: 64.84px;
    height: 37.27px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.mobileMoneyActive {
    border: 1px solid #1693C8;
    background: #EFF6F9;
}
.moov-money-icon-div:active {
    border: 1px solid #1693C8;
    background: #EFF6F9;
}
.active .mobilemoney-icon, .active .credit-card-icon {
    fill: #1693C8 !important;
}
.disabled {
    pointer-events: none;
}
.disabled .mobilemoney-icon {
    fill: #9BA2A9 !important;
}
.credit-card-icon,.mobilemoney-icon {
    fill: #9BA2A9 !important;
}

/* Messages div styles */
.messages-div {
    margin-top: 5px;
    padding: 2px 5px;
    height: 8vh;
    border: 1px solid #9BA2A9;
    border-radius: 5px;
    width: 80%;
    margin: auto;
}
.messages-title {
    display: flex;
    font-weight: bold;
}
.msg-title {
    flex: 1;
    margin-left: 5px;
}
.messages-content {
    font-size: 0.7em;
    display: flex;
    align-items: center;
    padding-top:0.5rem;
}
.message-success {
    border: 1px solid #80F0AB !important;
    color: #2BA359  !important;
    background: #E9F9F0 !important;
}
.message-error {
    border: 1px solid #FCDBDB !important;
    color: #AF2222  !important;
    background: #FAEDED !important;
}

/* Form styles */
.form-div {
    width: 90%;
    margin: auto;
    margin-bottom: 10px;
}
</style>
